import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "14",
  "aria-hidden": "true",
  viewBox: "0 0 16 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.625 1.781c.431-.344.5-.975.156-1.406a1 1 0 0 0-1.406-.156L9.98 3.734 6.6 1.2a1 1 0 0 0-1.225.019l-5 4a1.001 1.001 0 0 0 1.25 1.562l4.394-3.516L9.399 5.8a1 1 0 0 0 1.226-.019zM5 7v6a.999.999 0 1 0 2 0V7a.999.999 0 1 0-2 0m-4 3v3a.999.999 0 1 0 2 0v-3a.999.999 0 1 0-2 0m9-2a1 1 0 0 0-1 1v4a.999.999 0 1 0 2 0V9a1 1 0 0 0-1-1m3-1v6a.999.999 0 1 0 2 0V7a.999.999 0 1 0-2 0" }, null, -1)
  ])))
}
export default { render: render }